import { render, staticRenderFns } from "./TheTests.vue?vue&type=template&id=57f2c7c0&"
import script from "./TheTests.vue?vue&type=script&lang=js&"
export * from "./TheTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports